<template>
    <div class="full-container">
        <h1 class="top-text">Enrollment Fee</h1>
        <div class="window">
            <div id="top-row">
                <h2 class="top-description">Set up your Enrollment Fee & employee incentives.</h2>
                <!-- <button class="notes-btn grow-medium" @click="ShowNotes()">+ Add Notes</button> -->
            </div>
            <div class="body">
                <div class="body-columns-row">
                <div class="rewards-column-alt">
                    <div class="rewards-column" style="padding-bottom: 0.5em;">
                        <h2 class="left-text">New Patient Startup Benefits</h2>
                        <p class="show-hide-btn hover-grow" :class="{ 'show-hide-btn-active': showNewPatientBenefitsData }" @click="showNewPatientBenefitsData = !showNewPatientBenefitsData">
                            {{ showNewPatientBenefitsData ? 'Hide Data' : 'Show Data' }}
                        </p>
                        <div class="fee-data-container" style="width: 100%;" v-if="showNewPatientBenefitsData">
                            <div class="plan-row" style="font-weight: 600; border-bottom: 2px solid var(--color-dark-blue); padding-bottom: 0.5em; margin-bottom: 0.5em;">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Included Benefit</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black', textAlign: 'center' }">UCR</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black', textAlign: 'center' }">Discount</div>
                            </div>
                            <div class="plan-row">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Comprehensive Exam</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ GetBenefitUCR(9) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ calculateDiscountedBenefitPrice(9) }}</div>
                            </div>
                            <div class="plan-row">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Full-Mouth X-Rays</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ GetBenefitUCR(15) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ calculateDiscountedBenefitPrice(15) }}</div>
                            </div>
                            <div class="plan-row">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Adult Cleaning</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ GetBenefitUCR(0) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ calculateDiscountedBenefitPrice(0) }}</div>
                            </div>
                            <div style="width: 85%; height: 1px; background-color: black; margin-top: 0.5em; margin-bottom: 0.5em;"></div>
                            <div class="plan-row" style="font-weight: 600;">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Total</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'var(--color-bright-blue)' }">${{ GetBenefitUCR(9) + GetBenefitUCR(15) + GetBenefitUCR(0) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'var(--color-bright-blue)' }">${{ calculateDiscountedBenefitPrice(9) + calculateDiscountedBenefitPrice(15) + calculateDiscountedBenefitPrice(0) }}</div>
                            </div>
                        </div>
                        <div class="benefits-separator" v-if="showNewPatientBenefitsData"></div>
                        <div class="left-row" v-if="showNewPatientBenefitsData">
                            <h3 class="left-text">New Patient Special:</h3>
                            <div class="bubble-things">
                                <div class="plus-minus-buttons">
                                    <!-- <PlusMinusButton :char="'+'" @plusMinusClick="UpdateFirstVisitReimbursement"/>
                                    <PlusMinusButton :char="'-'" @plusMinusClick="UpdateFirstVisitReimbursement"/> -->
                                </div>
                                <div class="input-container">
                                    <span class="dollar-sign">$</span>
                                    <input class="bubble hover-grow" type="text" v-model="firstVisitReimbursement" @input="validateFirstVisitReimbursement($event.target.value)"/>
                                </div>
                            </div>
                        </div>
                        <div class="left-row">
                            <div class="left-text">
                                <h3>Enrollment Fee:</h3>
                            </div>
                            <div class="bubble-things">
                                <div class="plus-minus-buttons">
                                    <PlusMinusButton :char="'+'" @plusMinusClick="UpdateBaseEnrollmentFee"/>
                                    <PlusMinusButton :char="'-'" @plusMinusClick="UpdateBaseEnrollmentFee"/>
                                </div>
                                <div class="input-container">
                                    <span class="dollar-sign">$</span>
                                    <input class="bubble hover-grow" type="text" v-model="baseEnrollmentFee" @input="validateBaseEnrollmentFee($event.target.value)"/>
                                </div>
                            </div>
                        </div>
                        <div class="left-row">
                            <div class="left-text">
                                <h3>Staff Incentive:</h3>
                                <div class="checkbox-container grow-medium">
                                    <div class="checkbox" @click="toggleStaffIncentiveChecked($event)">
                                        <div class="checkbox-fill" v-if="staffIncentiveActive">
                                            <p class="checkbox-text">✓</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bubble-things" v-if="staffIncentiveActive">
                                <div class="plus-minus-buttons">
                                    <PlusMinusButton :char="'+'" @plusMinusClick="UpdateStaffIncentive"/>
                                    <PlusMinusButton :char="'-'" @plusMinusClick="UpdateStaffIncentive"/>
                                </div>
                                <div class="input-container">
                                    <span class="dollar-sign">$</span>
                                    <input class="bubble hover-grow" type="text" v-model="staffIncentive" @input="validateStaffIncentive($event.target.value)"/>
                                </div>
                            </div>
                            <div class="bubble-things" v-else>

                            </div>
                        </div>
                        <div class="left-row" v-if="staffIncentiveActive">
                            <h3 class="left-text">Total Enrollment Fee:</h3>
                            <div class="bubble-things">
                                <div class="plus-minus-buttons">
                                    <!-- Empty space to match layout -->
                                </div>
                                <div class="input-container" style="margin-right: 0.5em;">
                                    <div style="font-size: 2em; font-weight: 600; color: var(--color-bright-blue); text-align: center; width: 100%;">
                                        ${{ totalEnrollmentFee }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="rewards-column-alt">
                    <div class="rewards-column" style="padding-bottom: 0.5em;">
                        <h2 class="left-text">Existing Patient Startup Benefits</h2>
                        <p class="show-hide-btn hover-grow" :class="{ 'show-hide-btn-active': showExistingPatientBenefitsData }" @click="showExistingPatientBenefitsData = !showExistingPatientBenefitsData">
                            {{ showExistingPatientBenefitsData ? 'Hide Data' : 'Show Data' }}
                        </p>
                        <div class="fee-data-container" style="width: 100%;" v-if="showExistingPatientBenefitsData">
                            <div class="plan-row" style="font-weight: 600; border-bottom: 2px solid var(--color-dark-blue); padding-bottom: 0.5em; margin-bottom: 0.5em;">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Included Benefit</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black', textAlign: 'center' }">UCR</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black', textAlign: 'center' }">Discount</div>
                            </div>
                            <div class="plan-row">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Periodic Exams</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ GetBenefitUCR(3) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ calculateDiscountedBenefitPrice(3) }}</div>
                            </div>
                            <div class="plan-row">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">4 Bitewings & 2 PAs</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ GetBenefitUCR(4) + GetBenefitUCR(5) + GetBenefitUCR(6) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ calculateDiscountedBenefitPrice(4) + calculateDiscountedBenefitPrice(5) + calculateDiscountedBenefitPrice(6) }}</div>
                            </div>
                            <div class="plan-row">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Adult Cleaning</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ GetBenefitUCR(0) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'black' }">${{ calculateDiscountedBenefitPrice(0) }}</div>
                            </div>
                            <div style="width: 85%; height: 1px; background-color: black; margin-top: 0.5em; margin-bottom: 0.5em;"></div>
                            <div class="plan-row" style="font-weight: 600;">
                                <div class="plan-row-side plan-row-side-left"><p style="font-size: 1.3em; color: var(--color-dark-blue)">Total</p></div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'var(--color-bright-blue)' }">${{ GetBenefitUCR(3) + GetBenefitUCR(4) + GetBenefitUCR(5) + GetBenefitUCR(6) + GetBenefitUCR(0) }}</div>
                                <div class="plan-row-side plan-row-side-right" style="font-size: 1.5em;" :style="{ color: 'var(--color-bright-blue)' }">${{ calculateDiscountedBenefitPrice(3) + calculateDiscountedBenefitPrice(4) + calculateDiscountedBenefitPrice(5) + calculateDiscountedBenefitPrice(6) + calculateDiscountedBenefitPrice(0) }}</div>
                            </div>
                        </div>
                        <div class="benefits-separator" v-if="showExistingPatientBenefitsData"></div>
                        <div class="left-row" v-for="coupon in coupons" :key="coupon.id">
                            <div class="left-text">
                                <textarea 
                                    class="coupon-title-input hover-grow" 
                                    :value="coupon.title" 
                                    @input="updateCouponTitle(coupon.id, $event.target.value)"
                                    placeholder="Coupon Title"
                                    rows="1"
                                />
                            </div>
                            <div class="bubble-things">
                                <div class="plus-minus-buttons">
                                    <PlusMinusButton :char="'+'" @plusMinusClick="(value) => UpdateCoupon(coupon.id, value)"/>
                                    <PlusMinusButton :char="'-'" @plusMinusClick="(value) => UpdateCoupon(coupon.id, value)"/>
                                </div>
                                <div class="input-container">
                                    <span class="dollar-sign">$</span>
                                    <input class="bubble hover-grow" type="text" :value="coupon.dollarsOff" @input="validateCoupon(coupon.id, $event.target.value)"/>
                                </div>
                                <div class="trash-icon-container hover-grow" @click="RemoveCoupon(coupon.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="trash-icon">
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        <line x1="10" y1="11" x2="10" y2="17"></line>
                                        <line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="btn-container">
                            <button class="add-btn hover-grow" onmouseup="this.blur();" @click="AddCoupon">+ Add Coupon</button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <SaveChangesButton v-if="this.mode === 'view'" @btnPressed="GoToOverview()"></SaveChangesButton>
        <!-- <div class="modal-overlay" v-if="showNotes" @click.self="RemoveNotes">
            <NotesModal @click.stop @exitModal="RemoveNotes">
                
            </NotesModal>
        </div> -->
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { GoToComponent, CalculateComputedPlanPrice, InputToInteger } from '../utils/functions';
import PlusMinusButton from './PlusMinusButton.vue';
import SaveChangesButton from './SaveChangesButton.vue';
// import NotesModal from './modals/NotesModal.vue';
export default {
    components: {
        PlusMinusButton,
        SaveChangesButton,
        // NotesModal,
    },
    props: {
        mode: String,
    },
    data() {
        return {
            // showNotes: false,
            staffIncentiveActive: false,
            showNewPatientBenefitsData: false,
            showExistingPatientBenefitsData: false,
        }
    },
    methods: {
        toggleStaffIncentiveChecked() {
            this.staffIncentiveActive = !this.staffIncentiveActive;
            this.updateStaffIncentiveActive();
            this.UpdateEnrollmentFee();
        },
        ...mapActions(['updateRewardsPoints',
        'updateEnrollmentFee',
        'updateBaseEnrollmentFee',
        'updateStaffIncentive',
        'updateFirstVisitReimbursement',
        'updateBenefitByIdStore',
        'updateReimbursementPercentage',
        'togglePointsIncludedInPrice',
        'updatePlan',
        'updateStaffIncentiveActive',
        'setCoupons',
        'addCoupon',
        'removeCoupon',
        'updateCouponByID']),
        UpdateBaseEnrollmentFee(value){
            let result = 0;
            if(value === 1) {
                result = this.baseEnrollmentFee + 1
            }
            else if (value === -1 && this.baseEnrollmentFee === 0) {
                return
            }
            else {
                result = this.baseEnrollmentFee - 1;
            }
            this.updateBaseEnrollmentFee(result);
        },
        UpdateStaffIncentive(value){
            let result = 0;
            if(value === 1) {
                result = this.staffIncentive + 1
            }
            else if (value === -1 && this.staffIncentive === 0) {
                return
            }
            else {
                result = this.staffIncentive - 1;
            }
            this.updateStaffIncentive(result);
        },
        UpdateCoupon(couponId, value){
            console.log("UpdateCoupon called with couponId: ", couponId, " and value: ", value);
            const coupon = this.coupons.find(c => c.id === couponId);
            if (!coupon) {
                console.log("Coupon not found");
                return;
            }
            console.log("Coupon found: ", coupon);
            let result = 0;
            if(value === 1) {
                result = coupon.dollarsOff + 1
            }
            else if (value === -1 && coupon.dollarsOff === 0) {
                return
            }
            else {
                result = coupon.dollarsOff - 1;
            }
            
            const updatedCoupon = { ...coupon, dollarsOff: result };
            this.updateCouponByID(updatedCoupon);
            console.log("Updated coupon: ", updatedCoupon);
            console.log("Coupons: ", this.coupons);
        },
        UpdateFirstVisitReimbursement(value){
            let result = 0;
            if(value === 1) {
                result = this.firstVisitReimbursement + 1
            }
            else if (value === -1 && this.firstVisitReimbursement === 0) {
                return
            }
            else {
                result = this.firstVisitReimbursement - 1;
            }
            this.updateFirstVisitReimbursement(result);
        },
        UpdateRewardsPointsPerVisit(value){
            let result = 0;
            if(value === 1) {
                result = this.rewardsPointsPerVisit + 5
            }
            else if (value === -1 && this.rewardsPointsPerVisit === 0) {
                return
            }
            else {
                result = this.rewardsPointsPerVisit - 5;
            }
            this.updateRewardsPoints(result);
            this.updatePlans();
        },
        UpdateReimbursementPercentageLocal(value) {
            let result = 0;
            if(value === 1) {
                result = this.reimbursementPercentage + 5
                if(result > 100) {
                    result = 100;
                }
            }
            if(value === -1) {
                result = this.reimbursementPercentage - 5
                if(result < 0) {
                    result = 0;
                }
            }
            //console.log("Reimbursement Percentage = ", result);
            this.updateReimbursementPercentage(result);
            this.updatePlans();
        },
        updatePlans() {
            this.plans.forEach((plan) => {
                plan.price = CalculateComputedPlanPrice(this.$store, plan);
                this.updatePlan(plan);
            })
        },
        GoToOverview() {
            GoToComponent(this, 'overview');
        },
        // ShowNotes() {
        //     this.showNotes = true;
        // },
        // RemoveNotes() {
        //     this.showNotes = false;
        // },
        validateEnrollmentFee(val) {
            let result = InputToInteger(val);
            this.enrollmentFee = result;
        },
        validateFirstVisitReimbursement(val) {
            let result = InputToInteger(val);
            this.firstVisitReimbursement = result;
        },
        validateBaseEnrollmentFee(val) {
            let result = InputToInteger(val);
            this.baseEnrollmentFee = result;
        },
        validateStaffIncentive(val) {
            let result = InputToInteger(val);
            this.staffIncentive = result;
        },
        validateCoupon(couponId, val) {
            const coupon = this.coupons.find(c => c.id === couponId);
            if (!coupon) return;
            
            let result = InputToInteger(val);
            const updatedCoupon = { ...coupon, dollarsOff: result };
            this.updateCouponByID(updatedCoupon);
        },
        AddCoupon() {
            const nextId = this.coupons.length
                ? Math.max(...this.coupons.map(c => c.id)) + 1
                : 1;
            const newCoupon = {
                id: nextId,
                title: `Coupon ${nextId}`,
                dollarsOff: 0
            };
            this.addCoupon(newCoupon);
        },
        RemoveCoupon(couponId) {
            this.removeCoupon(couponId);
        },
        updateCouponTitle(couponId, newTitle) {
            const coupon = this.coupons.find(c => c.id === couponId);
            if (!coupon) return;
            
            const updatedCoupon = { ...coupon, title: newTitle };
            this.updateCouponByID(updatedCoupon);
        },
        validateRewardsPoints(val) {
            let result = InputToInteger(val);
            this.rewardsPointsPerVisit = result;
        },
        GetPlanTypeString(type) {
            return this.$store.getters.getPlanTypeFromInt(type);
        },
        GetBenefitUCR(id) {
            let benefit = this.$store.getters.getBenefitByID(id);
            if(benefit && benefit.price) {
                return benefit.UCR;
            }
            else {
                return benefit ? benefit.UCR : 0;
            }
        },
        UpdateEnrollmentFee() {
            if(this.staffIncentiveActive) {
                this.updateEnrollmentFee(this.baseEnrollmentFee + this.staffIncentive)
            }
            else {
                this.updateEnrollmentFee(this.baseEnrollmentFee)
            }
        },
        calculateDiscountedBenefitPrice(id) {
            let benefit = this.$store.getters.getBenefitByID(id);
            if (benefit && benefit.price !== 0 && benefit.price !== null) {
                return benefit.price;
            }
            else {
                return Math.ceil(benefit.UCR * (100 - this.restorativeWorkDiscount) / 100);
            }
        },
    },
    mounted() {
        this.staffIncentiveActive = this.$store.state.StaffIncentiveActive;
    },
    computed: {
        enrollmentFee: {
            get() {
                return this.$store.state.enrollmentFee;
            },
            set(val) {
                this.updateEnrollmentFee(val)
            }
        },
        baseEnrollmentFee: {
            get() {
                return this.$store.state.baseEnrollmentFee;
            },
            set(val) {
                this.updateBaseEnrollmentFee(val)
            }
        },
        staffIncentive: {
            get() {
                return this.$store.state.staffIncentive;
            },
            set(val) {
                this.updateStaffIncentive(val)
            }
        },
        firstVisitReimbursement: {
            get() {
                return this.$store.state.firstVisitReimbursement;
            },
            set(val) {
                this.updateFirstVisitReimbursement(val)
            }
        },
        plans() {
            return this.$store.getters.getActivePlans();
        },
        restorativeWorkDiscount() {
            const restorativeDiscount = this.$store.state.treatmentDiscounts.find(discount => discount.id === 0);
            return restorativeDiscount ? restorativeDiscount.percentOff : 0;
        },
        totalEnrollmentFee() {
            //Old code- uses New Patient Special
            // if (this.staffIncentiveActive) {
            //     return this.firstVisitReimbursement + this.staffIncentive;
            // } else {
            //     return this.firstVisitReimbursement;
            // }
            //New code- uses Base Enrollment Fee
            if (this.staffIncentiveActive) {
                return this.baseEnrollmentFee + this.staffIncentive;
            } else {
                return this.baseEnrollmentFee;
            }
            
        },
        coupons() {
            return this.$store.state.coupons;
        },
    },
    watch: {
        baseEnrollmentFee: {
            handler(newVal) {
                this.UpdateEnrollmentFee();
            },
            immediate: false
        },
        staffIncentive: {
            handler(newVal) {
                this.UpdateEnrollmentFee();
            },
            immediate: false
        },
        staffIncentiveActive: {
            handler(newVal) {
                this.UpdateEnrollmentFee();
            },
            immediate: false
        }
    }
}
</script>

<style scoped>
.top-text {
    margin: 0;
    margin-top: 1%;
    margin-bottom: 1%;
    color: var(--font-color-teal);
}

.full-container {
    width: 100%;
    height: 100%;
    max-height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin:0;
}

.window {
    width: 95%;
    max-height: 100%;
    height: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-radius: 20px;
}

#top-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

#top-row h2 {
    margin-left: 2em;
    margin-right: 2em;
    font-size: 1.3em;
}

.body {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1.5%;
}

.body-columns-row {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.rewards-column {
    margin-left: 5%;
    margin-right: 5%;
    display: flex;
    flex: 1;
    flex-direction: column;
    border: 2px solid var(--color-medium-gray);
    border-radius: 10px;
    align-items: center;
    justify-content: flex-start;
}

.rewards-column-alt {
    /* margin-left: 5%;
    margin-right: 5%; */
    display: grid; /* Use grid instead of flex */
    grid-template-rows: auto 1fr; /* Define rows: auto for the content size, 1fr takes remaining space */
    flex: 1;
    align-items: start; /* Align items to the start of the grid area */
}

.bubble-things {
    display: flex;
    flex: 3;
    align-items: center;
    justify-content: space-between;
}

.input-container {
    margin-left: 0.5em;
    position: relative;
    display: flex;
    align-items: center;
    flex: 2;
}

.bubble {
    background-color: white;
    color: var(--color-bright-blue);
    border: 2px solid var(--color-medium-light-gray);
    border-radius: 10px;
    font-size: 2em;
    font-weight: 900;
    width: 2.1em;
    max-width: 3em;
    height: 1.3em;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-left: 22px;
}

.coupon-bubble {
    width: 8em;
    max-width: 12em;
    font-size: 1em;
    font-weight: 600;
    text-align: left;
    padding-left: 0.5em;
    padding-right: 0.5em;
    color: var(--color-dark-blue);
}

.bubble:hover {
    border: 2px solid var(--color-light-blue);
}

.bubble:focus {
    border: 2px solid var(--color-bright-blue);
    outline: none;
}

.dollar-sign {
    position: absolute;
    color: var(--color-bright-blue);
    font-size: 1.5em;
    left: 5%;
}

.percent-sign {
    position: absolute;
    color: var(--color-bright-blue);
    font-size: 1.5em;
    font-weight: 600;
    right: -1%;
}


.plus-minus-buttons {
    margin-left: 1cm;
    flex: 2;
    justify-content: space-between;
}

.left-row {
    display: flex;
    flex: 2;
    align-items: center;
    justify-content: space-between;
    width: 95%;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
}

.left-text {
    display: flex;
    flex: 4;
    text-align: center;
}

.checkbox-container {
    margin-left: 1em;
    position:relative;
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
}

.checkbox {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid var(--color-dark-blue);
    border-radius: 5px;
    cursor: pointer;
}

.checkbox-fill {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    background-color: var(--color-dark-blue);
    border-radius: 3px;
    color: white;
}

.checkbox-text {
    margin: 0;
    font-size: 1.5em;
    left: 2px;
    top: -3px;
}

.top-row {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.plan-row {
    width: 100%;
    display: flex;
    justify-content: center;
}

.plan-row-side {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0.25em 0.5em;
}

.plan-row-side-left {
    flex: 3;
    display: flex;
    align-items: flex-start;
}

.plan-row-side-right {
    flex: 1;
}

.right-footer {
    margin-top: 0.5em;
    text-align: center;
}

p {
    margin: 0;
}

.fee-data-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.show-hide-btn {
    font-size: 1.2em;
    font-weight: 600;
    color: var(--color-bright-blue);
    cursor: pointer;
}

.show-hide-btn-active {
    margin-bottom: 1em;
}

.trash-icon-container {
    margin-left: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 40px;
    height: 40px;
}

.trash-icon {
    width: 24px;
    height: 24px;
    color: var(--color-dark-gray);
    transition: color 0.2s;
}

.trash-icon-container:hover .trash-icon {
    color: #e74c3c;
}

.btn-container {
    margin-top: 0.5em;
    display: flex;
    justify-content: center;
    width: 100%;
}

.add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid var(--color-light-blue);
    border-radius: 40px;
    height: 3em;
    width: 60%;
    background-color: white;
    color: var(--color-bright-blue);
    font-size: 1.2em;
    font-weight: 600;
    padding-right: 0.7em;
    padding-left: 0.7em;
    cursor: pointer;
}

.coupon-title-input {
    background-color: white;
    border: 2px solid var(--color-medium-light-gray);
    border-radius: 10px;
    padding: 0.5em 0.8em;
    font-size: 1.2em;
    font-weight: 600;
    color: var(--color-dark-blue);
    width: 100%;
    max-width: 400px;
    min-height: 2.5em;
    resize: none;
    font-family: inherit;
    line-height: 1.4;
    overflow-y: auto;
}

.coupon-title-input:hover {
    border: 2px solid var(--color-light-blue);
}

.coupon-title-input:focus {
    border: 2px solid var(--color-bright-blue);
    outline: none;
}

.benefits-separator {
    width: 90%;
    height: 2px;
    background-color: var(--color-medium-gray);
    margin: 1em auto;
}
</style>